<template>
  <div>
    <editor
      ref="toastuiEditor"
      v-model="editorText"
      :initialValue="editorText"
      @load="onEditorLoad"
      @change="onEditorChange"
      initialEditType="wysiwyg"
      :options="editorOptions"
      :height="heightEditor"
    />
  </div>
</template>

<script>
import mushroom from "viettoc-api";
import "@toast-ui/editor/dist/toastui-editor.css";
import { Editor } from "@toast-ui/vue-editor";

export default {
  props: {
    propDataEditor: String,
    height: String,
  },
  components: {
    editor: Editor,
  },
  data() {
    return {
      heightEditor: this.height ? this.height : "580px",
      editorText: this.propDataEditor,
      editorOptions: {
        hideModeSwitch: false,
        initialEditType: "markdown",
        hooks: {
          async addImageBlobHook(blob, callback) {
            let result = await mushroom.$file.uploadAsync({
              file: document.getElementById("toastuiImageFileInput").files[0], // required
            });
            const imgSrc = mushroom.$file.linkBuilder.thumb
              .id(result.result) // required
              .build();
            callback(imgSrc, "ảnh bài viết");
          },
        },
      },
    };
  },
  methods: {
    onEditorLoad() {
      this.editorText = this.propDataEditor || "";
      console.log("prop onload:", this.propDataEditor);
    },
    async onEditorChange() {
      let editor = this.$refs.toastuiEditor.invoke("getMarkdown");
      this.$emit("newData", editor);
    },
  },
  watch: {
    propDataEditor: function () {
      this.editorText = this.propDataEditor;
      this.editorText = this.$refs.toastuiEditor.invoke(
        "setMarkdown",
        this.propDataEditor
      );
    },
    height: function () {
      this.heightEditor = this.height;
    },
  },
};
</script>
<style scoped>
::v-deep .switch {
  width: 26px !important;
  height: 10px !important;
}
</style>
